import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { KeycloakAuthGuard, KeycloakService } from "keycloak-angular";
import { SharedServiceService } from "../pages/general/services/shared-service.service";
@Injectable({
    providedIn:'root'
})
export class AuthGuard extends KeycloakAuthGuard{
    constructor(protected routers:Router,
        protected keyCloakAngular:KeycloakService,
        protected shareService:SharedServiceService){
        super(routers,keyCloakAngular);
    }
     isAccessAllowed(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
        return new Promise(async (resolve,reject)=>{
            if(!this.authenticated){
                this.keyCloakAngular.login();
                resolve(false);
                return;
            }
            const requiredRoles= route.data["roles"];
            let granted:boolean = false;
            if(!requiredRoles || requiredRoles.length===0){
                granted=true;
            }else{
                for (const requiredRole of requiredRoles) {
                   if(this.roles.indexOf(requiredRole)>-1){
                    granted=true;
                    this.shareService.getKeyCloackUserInfo("New");
                    break;
                   }
                }
            }
            if(granted === false){
                resolve(granted);
            }
            resolve(granted);

        });
    }
}